import React, { useState, useEffect } from "react";
import CustomDropdown from "../CustomDropdown/CustomDropdown";
import styles from "./SubMapping.module.css";
import { getSaleSubmappingCategory } from "../../../../Bookclosure/Services/ApiHandler";

export default function Category({ SaleID, onMappingChange }) {
  const [selectedValues, setSelectedValues] = useState({});
  const [dropDownOptions, setDropDownOptions] = useState([]);
  const [categoryLabels, setCategoryLabels] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    async function fetchData() {
      try {
        setLoading(true);
        setError(null);

        const response = await getSaleSubmappingCategory(SaleID);
        console.log("Category API response:", response);

        const fields = response.fields || response.data?.fields || [];
        const labels = response.labelList || response.data?.labelList || [];

        setDropDownOptions(fields);
        setCategoryLabels(labels);
      } catch (err) {
        console.error("Error fetching category data:", err);
        setError("Failed to load dropdown data.");
      } finally {
        setLoading(false);
      }
    }

    fetchData();
  }, [SaleID]);

  const handleFieldChange = (label, value) => {
  const updated = { ...selectedValues, [label]: [value] };

  setSelectedValues(updated);

  onMappingChange(
    Object.entries(updated).map(([key, values]) => ({
      key,
      values
    }))
  );
};



  if (loading) return <div className={styles.loadingText}>Loading dropdown…</div>;
  if (error) return <div className={styles.errorText}>{error}</div>;

  return (

      <div className={styles.formGroup}>
        {categoryLabels.map((label) => (
          <CustomDropdown
            key={label}
            label={label}
            value={selectedValues[label] || ""}
            onChange={(value) => handleFieldChange(label, value)}
            options={dropDownOptions}
            placeholder="Map Column"
          />
        ))}
      </div>
   
  );
}